// extracted by mini-css-extract-plugin
export default {"header":"GL","container":"HL","accordeonitem":"IL","itemsticky":"JL","itemopen":"KL","open":"LL","productname":"ML","productinfo":"NL","flavorstext":"OL","invalidlimit":"PL","limit":"QL","scrollUpAccordion":"RL","wrapper":"SL"};
    if(module.hot) {
      // 1737143662460
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  